module.exports = __webpack_public_path__ + "static/media/navLogoH.e4c47dbb.png";